import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { EmptyStateComponent } from '@tecalisdev/infinity';
import { IOperationDetailResponse, isTfaOperationDetail, OPERATION_TYPE } from '../../../models/operations.models';
import { ListOperationsActivityComponent } from '../../../../shared/components/operations/common/list-operations-activity/list-operations-activity.component';

@Component({
	selector: 'app-operation-detail-tabs-activity',
	imports: [TranslatePipe, EmptyStateComponent, ListOperationsActivityComponent],
	templateUrl: './operation-detail-tabs-activity.component.html',
	styleUrl: './operation-detail-tabs-activity.component.scss',
})
export class OperationDetailTabsActivityComponent {
	@Input() detail: IOperationDetailResponse;

	private readonly supportedOperationTypes = new Set<OPERATION_TYPE>([
		OPERATION_TYPE.OCR,
		OPERATION_TYPE.POL,
		OPERATION_TYPE.DOCUMENTS,
		OPERATION_TYPE.CONNECTIONS,
		OPERATION_TYPE.FINANCIAL_EVALUATION,
		OPERATION_TYPE.EVALUATION,
		OPERATION_TYPE.BORME,
		OPERATION_TYPE.FORM,
	]);

	public isUnsupportedOperationType(): boolean {
		if (isTfaOperationDetail(this.detail)) {
			return false;
		}
		const operationType = this.detail?.operation_type_name as OPERATION_TYPE | undefined;
		if (!operationType) {
			return true;
		}
		return !this.supportedOperationTypes.has(operationType);
	}
}
